import { observable, ObservableMap, runInAction } from 'mobx';
import { EventEmitter } from 'events';
import { TypedEmitter } from '../util';

export class SelectMapState<K, V> {
  private map: ObservableMap<K, V>;
  readonly events = new EventEmitter() as TypedEmitter<{
    isDisabled: (item: V) => boolean;
  }>;

  constructor() {
    this.map = observable.map<K, V>([], {
      deep: false,
    });
  }

  set(key: K, value: V) {
    if (
      this.events.listeners('isDisabled').some((listener) => listener(value))
    ) {
      return;
    }

    runInAction(() => {
      this.map.set(key, value);
    });
  }

  forceSet(key: K, value: V) {
    runInAction(() => {
      this.map.set(key, value);
    });
  }

  get(key: K) {
    return this.map.get(key);
  }

  values() {
    return this.map.values();
  }

  entries() {
    return this.map.entries();
  }

  clear() {
    return this.map.clear();
  }
}
